import {
	Component,
	effect,
	inject,
	signal,
	TemplateRef,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';
import { GoogleMapsModule, MapAdvancedMarker } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { Title } from '@angular/platform-browser';
import { takeUntil } from 'rxjs';

import { BaseMap } from '../../../../shared/base-classes/base-map.component';
import { MapSearchBarComponent } from '../../../../shared/components/map-search-bar/map-search-bar.component';
import { MapService } from '../../../../shared/services/map.service';
import { PollService } from '../../../../shared/services/polling.service';
import { GpsTrackingService } from '../../../../shared/services/gps-tracking.service';
import { VehicleLinkPillComponent } from '../../vehicles/components/vehicle-link-pill/vehicle-link-pill.component';

@Component({
	selector: 'app-tracking',
	templateUrl: 'tracking.component.html',
	imports: [
		GoogleMapsModule,
		VehicleLinkPillComponent,
		MatIconModule,
		MapSearchBarComponent,
	],
	host: {
		class: 'h-screen',
	},
	styleUrls: ['tracking.component.scss'],
})
export class TrackingComponent extends BaseMap {
	mapService = inject(MapService);
	#title = inject(Title);
	#trackingService = inject(GpsTrackingService);
	#pollService = inject(PollService);
	viewContainerRef = inject(ViewContainerRef);
	vehiclesMarkers: Map<number, MapAdvancedMarker> = new Map();
	@ViewChild('markerTemplate') markerTemplateRef: TemplateRef<any>;

	async ngAfterViewInit() {
		await super.ngAfterViewInit();
	}
	pingerSignal = signal(1);

	ionViewDidEnter() {
		this.#title.setTitle('Tracking');
	}

	constructor() {
		super();
		this.options.scrollwheel = true;

		this.#pollService.getPoll().subscribe(() => {
			if (this.pingerSignal() === 1) {
				this.pingerSignal.set(0);
			} else {
				this.pingerSignal.set(1);
			}
		});

		effect(() => {
			this.pingerSignal();
			this.#trackingService
				.getVehiclesStats()
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((res) => {
					// Remove markers that are not in the response
					this.vehiclesMarkers.forEach((marker, id) => {
						if (!res.data?.find((item) => item.vehicleId === id)) {
							this.mapService.removeMarker(marker);
							this.vehiclesMarkers.delete(id);
						}
					});

					// Add or update markers
					res.data?.forEach((item) => {
						if (this.vehiclesMarkers.has(item.vehicleId)) {
							// Update the marker's position
							this.mapService.updateMarkerPosition(
								this.vehiclesMarkers.get(item.vehicleId),
								item.coordinates,
							);
						} else {
							// Add a new marker
							this.mapService
								.addMarker(
									item.coordinates,
									{
										id: item.vehicleId,
										displayValue: item.vehicleLicensePlate ?? item.vehicleVin,
									},
									this.markerTemplateRef,
									this.map,
									this.viewContainerRef,
								)
								.then((marker) => {
									this.vehiclesMarkers.set(item.vehicleId, marker);
								});
						}
					});
				});
		});
	}
}
